import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import UploadPage from "@/pages/UploadPage";
import TablePage from "@/pages/TablePage";
import EmptyTablePage from "@/pages/EmptyTablePage";
import MergePage from "@/pages/MergePage";
import HistoryPage from "@/pages/HistoryPage";
import { Sidebar } from "@/components/layout/Sidebar";

function App() {
  return (
    <div className="min-h-screen app-bg">
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <div className="flex min-h-screen flex-col lg:flex-row">
          <Sidebar />
          <div data-testid="app-content" className="min-w-0 flex-1">
            <Routes>
              <Route path="/unisci" element={<MergePage />} />
              <Route path="/" element={<UploadPage />} />
              <Route path="/tabella" element={<EmptyTablePage />} />
              <Route path="/tabella/:jobId" element={<TablePage />} />
              <Route path="/storico" element={<HistoryPage />} />
            </Routes>
          </div>
        </div>
      </BrowserRouter>
    </div>
  );
}

export default App;
